export default "__VITE_ASSET__BnWsv9pc__"